// extracted by mini-css-extract-plugin
export default {"root":"DataGridHeader_root__kJBKh"};